import { Layout, Popover } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleCollapsedSideNav } from '../../../appRedux/actions';
import AppNotification from '../../../components/layout/AppNotification';
import MailNotification from '../../../components/layout/MailNotification';
import UserInfo from '../../../components/layout/UserInfo';
import { TAB_SIZE } from '../../../constants/ThemeSetting';
import HorizontalNav from '../HorizontalNav';

const { Header } = Layout;

const HorizontalDark = () => {
	const navCollapsed = useSelector(({ common }: any) => common.navCollapsed);
	const width = useSelector(({ common }: any) => common.width);
	const dispatch = useDispatch();

	return (
		// 7TH SECTION
		<div className="gx-header-horizontal gx-header-horizontal-dark">
			<Header className="gx-header-horizontal-main">
				<div className="gx-container">
					<div className="gx-header-horizontal-main-flex">
						<div className="gx-d-block gx-d-lg-none gx-linebar gx-mr-xs-3">
							<i
								className="gx-icon-btn icon icon-menu"
								onClick={() => {
									dispatch(toggleCollapsedSideNav(!navCollapsed));
								}}
							/>
						</div>
						<Link to="/realtimedashboard" className="gx-d-block gx-d-lg-none gx-pointer gx-mr-xs-3 gx-pt-xs-1 gx-w-logo">
							<img alt="" src="/assets/images/tobot.png" width={90} />
						</Link>
						<Link to="/realtimedashboard" className="gx-d-none gx-d-lg-block gx-pointer gx-mr-xs-5 gx-logo">
							<img alt="" src="/assets/images/logowhite.png" width={90} />
						</Link>

						<ul className="gx-header-notifications gx-ml-auto">
							<li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none"></li>

							<li className="gx-notify">
								<Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={<AppNotification />} trigger="click">
									<span className="gx-pointer gx-d-block">
										<i className="icon icon-notification" />
									</span>
								</Popover>
							</li>

							<li className="gx-msg">
								<Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={<MailNotification />} trigger="click">
									<span className="gx-pointer gx-status-pos gx-d-block">
										<i className="icon icon-chat-new" />
										<span className="gx-status gx-status-rtl gx-small gx-orange" />
									</span>
								</Popover>
							</li>

							<li className="gx-user-nav" style={{ marginLeft: '0px' }}>
								<UserInfo />
							</li>
						</ul>
					</div>
				</div>
			</Header>

			{width >= TAB_SIZE && (
				<div className="gx-header-horizontal-nav">
					<div className="gx-container">
						<div className="gx-header-horizontal-nav-flex">
							<HorizontalNav />
							<ul className="gx-header-notifications gx-ml-auto"></ul>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
export default HorizontalDark;
